import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import aboutImage from '../assets/about-banner.png';

const features = [
  'Synchronized global watch parties — thousands of viewers watching your film at the exact same moment',
  'Live audience reactions and engagement tracked in real time',
  'Direct filmmaker Q&As with your audience immediately after screening',
  'No geographical barriers — Nairobi, New York, São Paulo, Berlin, all in the same room',
  'Real-time engagement data delivered to every filmmaker after their screening',
];

export default function AboutSection() {
  return (
    <section id="about" className="max-w-[1200px] mx-auto px-6 py-24">
      <div className="grid grid-cols-1 lg:grid-cols-2" style={{ gap: '5rem' }}>
        {/* Left Column */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <span
            className="font-mono text-teal uppercase block mb-4"
            style={{
              fontSize: '0.7rem',
              letterSpacing: '0.25em',
            }}
          >
            What is Synema Film Fest
          </span>

          <h2
            className="font-display text-white leading-none mb-6"
            style={{ fontSize: 'clamp(2.5rem, 5vw, 4rem)' }}
          >
            Cinema was always meant to be shared.
          </h2>

          <p className="text-light/70 text-base leading-relaxed mb-8">
            Synema Interactive Film Festival is the world's first communal streaming
            film festival — built on Mindi.TV, where audiences watch together in real
            time, react together, and connect directly with the filmmakers behind the
            work.
          </p>

          <ul className="space-y-4">
            {features.map((feature, i) => (
              <motion.li
                key={i}
                className="flex items-start gap-3 text-light/70 text-sm leading-relaxed"
                initial={{ opacity: 0, x: -15 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: 0.1 * i }}
              >
                <span
                  className="inline-block w-2 h-2 rounded-full bg-teal mt-1.5 shrink-0"
                />
                {feature}
              </motion.li>
            ))}
          </ul>

          <Link
            to="/about"
            className="inline-block mt-8 text-teal text-[0.82rem] font-medium tracking-[0.08em] uppercase border-b border-teal pb-[2px] hover:opacity-80 transition-opacity"
          >
            Learn more about Synema Film Fest →
          </Link>
        </motion.div>

        {/* Right Column — Festival Banner */}
        <motion.div
          className="flex items-center"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.2 }}
        >
          <img
            src={aboutImage}
            alt="Synema Interactive Film Festival"
            className="w-full rounded"
            style={{ border: '1px solid rgba(42,191,163,0.15)' }}
          />
        </motion.div>
      </div>
    </section>
  );
}
